export const FEATURE_STATUS_CHANGED = "books/featureStatusChanged";
export const SEARCH_TEXT_CHANGED = "books/searchTextChanged";
